var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[(_vm.titleStatus)?_c('page-title',{attrs:{"title":_vm.$t('aboutUs.items')}}):_vm._e(),_c('main-table',{attrs:{"fields":_vm.fields,"list_url":'admin/about-us',"reloadData":_vm.reloadData,"params":_vm.filter,"createStatus":false,"excelFields":_vm.excelFields,"excelName":"aboutUs"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }